"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditModule = void 0;
const router_1 = require("client/components/router");
const audit_sheet_1 = require("./modules/audit-sheet");
class AuditModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("audit", /^\/audit?$/, audit_sheet_1.AuditSheet);
    }
}
exports.AuditModule = AuditModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/audit/audit.tsx
// module id = 3266
// module chunks = 0